import { PaymentMethodEnum } from 'api';
import { SelectField, SelectFieldProps, SelectOption } from 'form';

type Props = Omit<SelectFieldProps, 'options' | 'label' | 'name'> & {
  required?: boolean;
  label?: string;
  name?: string;
};

const PAYMENT_METHOD_OPTIONS: SelectOption[] = [
  {
    label: 'Document against payment',
    value: PaymentMethodEnum.DP,
  },
  {
    label: 'Telegraphic transfer',
    value: PaymentMethodEnum.TT,
  },
];

export const PaymentMethod = ({
  label = 'Payment method',
  name = 'payment_method',
  required = true,
  ...rest
}: Props) => {
  return <SelectField label={label} name={name} options={PAYMENT_METHOD_OPTIONS} required={required} {...rest} />;
};
